import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 工具函数：判断登录端
function isMobile() {
  const ua = navigator.userAgent
  console.log('打开的设备端口', ua)
  console.log('123', /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua))
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
}

// PC
import home from '../page/pc/home.vue';
import about from '../page/pc/about.vue';
import solutions from '../page/pc/solutions.vue';
import technology from '../page/pc/technology.vue';
import locations from '../page/pc/locations.vue';
import franchise from '../page/pc/franchise.vue';
import contact from '../page/pc/contact.vue';
import blogs from '../page/pc/blogs.vue';
import blogsDetail from '../page/pc/blogsDetail.vue';
import seach from '../page/pc/seach.vue'
import form from '@/page/pc/form.vue'
// MOBILE
import aboutMo from '../page/mobile/about.vue';
import solutionMo from '../page/mobile/solutions.vue';
import technologyMo from '../page/mobile/technology.vue';
import locationsMo from '../page/mobile/locations.vue';
import franchiseMo from '../page/mobile/franchise.vue';
import contactMo from '../page/mobile/contact.vue';
import blogsMo from '../page/mobile/blogs.vue';
import seachMo from '../page/mobile/seach.vue'
import formMo from '@/page/mobile/form.vue'
import blogsDetailMo from '@/page/mobile/blogsDetail.vue'

// FINALLY
import homeFinally from '../page/finally/home.vue';
import aboutFinally from '../page/finally/about.vue';

import treatmentsFinally from '../page/finally/treatments.vue';
import contactFinally from '../page/finally/contact.vue'
import produtosFinally from '../page/finally/produtos.vue'
import franchiseFinally from '../page/finally/franchise.vue'
import locationsFinally from '../page/finally/locations.vue';
import theEditFinally from '../page/finally/theEdit.vue';
import theEditDetail from '@/page/finally/theEditDetail.vue';
import privacyFinally from '@/page/finally/privacyPolicy.vue'
// const routes = [
//   { path: '/', component: home },
//   { path: '/page/pc/about', component: about },
//   { path: '/page/pc/solutions', component: solutions },
// ];
// 首页判断
const HomeAsync = () => isMobile()
  ? import('@/page/mobile/home.vue')
  : import('@/page/pc/home.vue')
const routes = [
  { path: '/', component: homeFinally },
  { path: '/about', component: aboutFinally },
  // { path: '/about', component: isMobile() ? aboutMo : about },
  { path: '/solutions', name: 'solutions', component: treatmentsFinally },
  { path: '/technology', component: produtosFinally },
  { path: '/locations', component: locationsFinally },
  { path: '/franchise', component: franchiseFinally },
  { path: '/contact', component: contactFinally },
  { path: '/blogs', name: 'blogs', component: theEditFinally },
  { path: '/theEditDetail/:id', name: 'theEditDetail', component: theEditDetail },
  // { path: '/seach', component: isMobile() ? seachMo : seach },
  { path: '/seach', component: seach },
  { path: '/form', component: isMobile() ? formMo : form },
  { path: '/detail', name: 'detail', component: isMobile() ? blogsDetailMo : blogsDetailMo },
  { path: '/privacy', component: privacyFinally },
  {
    path: '/blogsDetail/:id/:type',
    name: 'blogsDetail',
    component: isMobile() ? blogsDetail : blogsDetail,
    props: (route) => ({
      id: String(route.params.id),
      type: route.params.type
    })
  },
  {
    path: '/blogsDetailMo/:id',
    name: 'blogsDetailMo',
    component: blogsDetailMo,
    props: (route) => ({
      id: String(route.params.id),
    })
  },
  
];
console.log('routes', routes)

const router = new VueRouter({
  mode: 'hash', // 使用HTML5 History模式
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
// 在这里添加 afterEach 导航守卫
// router.afterEach((to, from) => {
//   console.log('路由跳转完成', to, from);
//   每次路由跳转后都滚动到顶部
//   window.scrollTo(0, 0);
// });
export default router;